module.exports = __webpack_public_path__ + "static/media/dots.9f894b48.gif";